<div class="w-full h-full flex flex-col items-center gap- px-4 py-8">
  <br/>
  <div class="max-w-[580px] w-full flex flex-col gap-6">
    <h1 class="titulo">Validación de Identidad con Clave Única</h1>
    <p class="texto">
      Al apretar en el botón Clave Única serás redirigido a una página para
      ingresar tu clave.
    </p>
    <p class="texto">
      Recuerda que necesitas tener acceso al correo que tienes registrado en
      Clave Única ya que lo necesitarás durante el proceso.
    </p>
    <div class="w-full flex justify-center">
      <app-claveunica-button [tokenCU]="tokenCU" />
    </div>
  </div>
</div>
